<script>
	import { api_spawnExperiment } from "../stores.js";
	import { arrayObjects2CSV, sortByKey } from "../utils.js";
	import Clipboard from "svelte-clipboard";

	export let conditions;
	let secret = "";
	let message = "";
	let experiment_id;
	let studyURL = "https://www.yourfeed.social";
	let copiedID = false;
	let copiedIDText = "Copy ID";
	let copiedURL = false;
	let copiedURLText = "Copy URL";
	let downloadParamsText = "Download";
	let finalParams;
	let showError = false;

	const toCSV = (data) => {
		data = sortByKey(data, "condition");
		data = sortByKey(data, "param");
		console.log(data);
		let csv = arrayObjects2CSV(data);

		// document.write(csv);
		let hiddenElement = document.createElement("a");
		hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
		hiddenElement.target = "_blank";
		let filename;
		if (experiment_id) {
			filename = experiment_id + "_experiment_parameters.csv";
		} else {
			filename = "experiment_parameters.csv";
		}
		hiddenElement.download = filename;
		hiddenElement.click();
	};

	const processParamsForAPI = (conditions) => {
		console.log("conditions:", conditions);
		message = "";
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		// console.log("paramsSelected", paramsSelected);

		let conditionSettings = [];

		// add n-conditions
		for (let i = 0; i < conditions; i++) {
			let obj = {
				condition: i + 1,
				param: "n-conditions",
				value: conditions,
			};
			conditionSettings.push(obj);
		}

		for (let key in paramsSelected) {
			conditionSettings = conditionSettings.concat(paramsSelected[key]);
		}

		// ensure all conditions have entity sets
		const entitySets = conditionSettings.filter(
			(i) => i.param == "entity_sets"
		);
		entitySets.forEach((obj) => {
			if (obj.value.length == 0) {
				conditionSettings = [];
				message =
					"You need to select at least one set per condition under the Cards section.";
			}
		});
		if (conditionSettings.length == 0) {
			return false;
		}

		// if feed algorithm is not random for a condition, overwrite to always show all cards in all sets
		let feedAlg = conditionSettings.filter((i) => i.param == "algorithm");
		const entitySetSize = JSON.parse(
			localStorage.getItem("createStudyPulledEntitySets")
		)["entity_set_n"];
		let conditionsToOverwrite = feedAlg.filter((i) => i.value != "random");
		for (let i = 0; i < conditionsToOverwrite.length; i++) {
			for (let j = 0; j < conditionSettings.length; j++) {
				if (
					conditionSettings[j].condition ==
						conditionsToOverwrite[i].condition &&
					conditionSettings[j].param == "entity_sets"
				) {
					let entitySets = conditionSettings[j].value;
					for (let k = 0; k < entitySets.length; k++) {
						entitySets[k].number_to_show =
							entitySetSize[entitySets[k].entity_set];
					}
					conditionSettings[j].value = entitySets;
				}
			}
		}

		// convert null or undefined to entity_sets (avoid JSON errors in server)
		conditionSettings.forEach((obj, idx) => {
			if (obj.value === "null" || obj.value === "undefined") {
				conditionSettings[idx].value = "";
			}
		});

		// convert "" feed-button values to "no"
		conditionSettings.forEach((obj, idx) => {
			if (obj.param.includes("feed-button-") && obj.value === "") {
				conditionSettings[idx].value = "no";
			}
		});

		// sort
		conditionSettings = sortByKey(conditionSettings, "condition");
		conditionSettings = sortByKey(conditionSettings, "param");
		console.log("conditionSettings", conditionSettings);

		localStorage.setItem(
			"createStudyConditionSettings",
			JSON.stringify(conditionSettings)
		);

		// stringify
		let keys = ["entity_sets", "forms"];
		for (let i = 0; i < conditionSettings.length; i++) {
			if (keys.includes(conditionSettings[i].param)) {
				conditionSettings[i].value = JSON.stringify(
					conditionSettings[i].value
				);
			}
		}

		// encode
		keys = [
			"platform",
			"redirect-url",
			"completion-code",
			"consent",
			"custom-msg",
			"instruct",
		];
		for (let i = 0; i < conditionSettings.length; i++) {
			if (keys.includes(conditionSettings[i].param)) {
				conditionSettings[i].value = encodeURIComponent(
					conditionSettings[i].value
				);
			}
		}

		return conditionSettings;
	};
	$: localStorage.getItem("createStudyParamsSelected");

	const handleVerify = () => {
		finalParams = processParamsForAPI(conditions);
		console.log("finalParams", finalParams);
		if (!finalParams) {
			message =
				"You need to select at least one set per condition under the Cards section.";
			showError = true;
		} else {
			if (!experiment_id) {
				message = "";
			}
			toCSV(finalParams);
		}
	};

	const handleSubmit = () => {
		finalParams = processParamsForAPI(conditions);
		if (!finalParams) {
			message =
				"You need to select at least one set per condition under the Cards section.";
			showError = true;
			return false;
		}
		console.log("finalParams", finalParams);
		if (secret !== SECRET_CODE) {
			message = "🤖 Wrong secret code! Are you human? 🤖";
		} else {
			spawnExperiment(finalParams);
		}
	};

	async function spawnExperiment(conditionSettings) {
		console.log("Spawning experiment...");
		const resp = await fetch($api_spawnExperiment, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				condition_settings: conditionSettings,
			}),
		});
		const response = await resp.json();
		let data;
		if (response.success === "true") {
			console.log("Created experiment successfully");
			data = response.data;
			experiment_id = data.experiment_id;
			studyURL += "?experiment_id=" + experiment_id;
			message = "Study created: ";
			showError = false;
		} else {
			console.log("Failed to create experiment");
			message = "Whoops, failed to create study.";
		}
	}
</script>

<section>
	<hr />
	<h3>Enter secret code to create study</h3>

	<input
		class="input-secret"
		name="secret"
		type="text"
		bind:value={secret}
		required
	/>
	<button
		class="button-submit"
		disabled={false}
		on:click|preventDefault={handleVerify}>Verify parameters</button
	>
	<button
		class="button-submit"
		disabled={false}
		on:click|preventDefault={handleSubmit}>Create Study</button
	>

	{#if showError}
		<p><strong>{message}</strong></p>
	{/if}

	{#if experiment_id}
		<h3>{message}{experiment_id}</h3>
		<p style="color:red">
			Save your experiment ID and URL! You'll need them to run your study
			and download data later. Also, download the parameters you've
			defined above.
		</p>
		<p class="created">
			<button
				on:click|preventDefault={() => {
					toCSV(finalParams);
				}}
				class="copy-button">{downloadParamsText}</button
			>
			<Clipboard
				text={experiment_id}
				let:copy
				on:copy={() => {
					copiedID = true;
					copiedIDText = "Copied ID";
				}}
			>
				<button on:click|preventDefault={copy} class="copy-button"
					>{copiedIDText}</button
				>
			</Clipboard>
			{#if copiedID}
				<span style="font-size:0.6em;margin-left:2px"
					>{experiment_id}</span
				>
			{/if}
			<Clipboard
				text={studyURL}
				let:copy
				on:copy={() => {
					copiedURL = true;
					copiedURLText = "Copied URL";
				}}
			>
				<button on:click|preventDefault={copy} class="copy-button"
					>{copiedURLText}</button
				>
			</Clipboard>
			{#if copiedURL}
				<span style="font-size:0.6em;margin-left:2px">{studyURL}</span>
			{/if}
		</p>
	{/if}
</section>

<style>
	.button-submit {
		display: inline;
	}
	.input-secret {
		display: inline;
		width: 89px;
	}
</style>
